<template>
  <loader v-if="key == null" />

  <base-single-key-rp
    v-else
    :code="key"
    :index="index"
    :url="url"
    @backToLesson="backToLesson"
    @stopRegistration="stopRegistration"
  />
</template>

<script>
import Echo from 'laravel-echo'
import BaseSingleKeyRp from '@/employees/DynamicKey/BaseSingleKeyRp'
import { defaultErrorMessage } from '@/helpers'
import axios from 'axios'

export default {
  name: 'SingleKeyRp',

  components: { BaseSingleKeyRp },

  props: {
    backToLessonUrl: {
      required: true,
      type: String,
    },
    originalUrl: {
      required: true,
      type: String,
    },
    originalIndex: {
      required: true,
      type: String,
    },
    originalKey: {
      required: true,
      type: String,
    },
    rpId: {
      required: true,
      type: String,
    },
  },

  data () {
    return {
      url: null,
      index: null,
      key: null,
    }
  },

  created () {
    this.url = this.originalUrl
    this.index = this.originalIndex
    this.key = this.originalKey
    this.setupWebsocket()
  },

  methods: {
    backToLesson () {
      window.location.href = this.backToLessonUrl
    },

    setupWebsocket () {
      this.echo = new Echo({
        broadcaster: 'pusher',
        key: document.head.querySelector('meta[name="pusher-key"]').content,
        wsHost: document.head.querySelector('meta[name="pusher-host"]').content,
        wsPort: document.head.querySelector('meta[name="pusher-port"]').content,
        disableStats: true,
        encrypted: false,
        forceTLS: false,
        enabledTransports: ['ws', 'wss'],
      })

      this.echo.private('rp.' + this.rpId).listen('UpdatedSingleKey', (e) => {
        this.url = e.url
        this.index = e.index
        this.key = e.key
      })
    },

    stopRegistration () {
      const urlPath = window.location.pathname

      axios.post(`${urlPath}/close`).then(() => {
        this.backToLesson()
      }).catch(error => defaultErrorMessage(error))
    },
  },
}
</script>

<style scoped>
</style>
